import { apiService } from './api';
import { PrintConfiguration, CreatePrintConfigurationRequest, UpdatePrintConfigurationRequest } from '../types';

export const printConfigurationService = {
  async create(data: CreatePrintConfigurationRequest): Promise<PrintConfiguration> {
    const response = await apiService.post<PrintConfiguration>('/print-configurations', data);
    return response.data;
  },

  async update(id: string, data: UpdatePrintConfigurationRequest): Promise<PrintConfiguration> {
    const response = await apiService.put<PrintConfiguration>(`/print-configurations/${id}`, data);
    return response.data;
  },

  async getAll(organizationCode: string, restaurantId?: string | null): Promise<PrintConfiguration[]> {
    const response = await apiService.get<PrintConfiguration[]>('/print-configurations', {
      org: organizationCode,
      ...(restaurantId && { restaurantId })
    });
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await apiService.delete<void>(`/print-configurations/${id}`);
  }
};
